// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ISO 639-2 Bibliographical language codes
 * @export
 */
export const ISO6392B = {
  Eng: "eng",
  Dut: "dut",
  Zxx: "zxx",
} as const;
export type ISO6392B = (typeof ISO6392B)[keyof typeof ISO6392B];

export function instanceOfISO6392B(value: any): boolean {
  for (const key in ISO6392B) {
    if (Object.prototype.hasOwnProperty.call(ISO6392B, key)) {
      if (ISO6392B[key as keyof typeof ISO6392B] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ISO6392BFromJSON(json: any): ISO6392B {
  return ISO6392BFromJSONTyped(json, false);
}

export function ISO6392BFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISO6392B {
  return json as ISO6392B;
}

export function ISO6392BToJSON(value?: ISO6392B | null): any {
  return value as any;
}

export function ISO6392BToJSONTyped(value: any, ignoreDiscriminator: boolean): ISO6392B {
  return value as ISO6392B;
}
